<div *ngIf="ctx" class="btn-group" role="group">
  <button *ngFor="let view of viewKinds"  type="button" class="btn btn-light" tooltip="{{view.info}}" placement="bottom" container="body" [ngClass]="{'active': ctx.ViewKind == view.kind }" (click)="changeViewKind(view.kind)"><i [ngClass]="view.icon"></i></button>
</div>